export default __webpack_public_path__ + "static/media/ksa.42648a7e.svg";